// extracted by mini-css-extract-plugin
export var container = "ShipmentTracker_container__LhCcR";
export var delivered = "ShipmentTracker_delivered__Aqnd-";
export var error = "ShipmentTracker_error__uV00y";
export var inTransit = "ShipmentTracker_inTransit__7Tr4t";
export var outForDelivery = "ShipmentTracker_outForDelivery__lSwYh";
export var packageShipped = "ShipmentTracker_packageShipped__N-XOU";
export var processingShipment = "ShipmentTracker_processingShipment__KF5DF";
export var shipmentDeliveredCheckmark = "ShipmentTracker_shipmentDeliveredCheckmark__38O79";
export var shipmentEstimatedDate = "ShipmentTracker_shipmentEstimatedDate__d9kM3";
export var shipmentProgressBar = "ShipmentTracker_shipmentProgressBar__SteKQ";
export var shipmentProgressBarBackground = "ShipmentTracker_shipmentProgressBarBackground__vUFxg";
export var shipmentProgressContainer = "ShipmentTracker_shipmentProgressContainer__Y0fBV";
export var shipmentStatus = "ShipmentTracker_shipmentStatus__yVAG1";